import React from 'react';
import cn from 'classnames';

import { Line } from '../Line';

import styles from './Lines.module.scss';

const Lines = ({
  className,
  lineDrawing,
  lines,
  containerRef,
}: {
  className: any;
  lineDrawing: any;
  lines: any;
  containerRef: any;
}) => {
  return (
    <div className={cn(styles.lines, className)}>
      <div
        className={styles.inner}
        ref={containerRef}
        style={{
          cursor: lineDrawing ? 'none' : 'auto',
        }}
      >
        {lines.map((line: any, index: any) => (
          <Line
            key={line.startId + line.startType}
            containerRef={containerRef}
            {...line}
          />
        ))}
      </div>
    </div>
  );
};

export default React.memo(Lines) as any;
